export default "__VITE_ASSET__DtvnDHTp__"